import { useDispatch } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { StoragesValuesView } from "../../../redux/slices/grainTracker/grainTrackerTypes";

import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { v4 as uuidv4 } from "uuid";

import ceroPercent from "../../../assets/images/silosGrainWise/cero.svg";
import twentyFivePercent from "../../../assets/images/silosGrainWise/twentyFive.svg";
import fiftyPercent from "../../../assets/images/silosGrainWise/fifty.svg";
import seventyFivePercent from "../../../assets/images/silosGrainWise/seventyFive.svg";
import undredPercent from "../../../assets/images/silosGrainWise/hundred.svg";
import { fetchSelectedBinInformation } from "../../../redux/actions/locations/locationDetailsAsync";
import { formatValueWithTooltip } from "./selectedBin";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    setBin: (storageId: string) => {
      dispatch(fetchSelectedBinInformation({ storageId }));
    },
  };
};

export const showCorrectSVG = (getPercentage: number) => {
  if (getPercentage >= 0 && getPercentage <= 24.99) {
    return twentyFivePercent;
  }
  if (getPercentage >= 25 && getPercentage <= 49.99) {
    return twentyFivePercent;
  }

  if (getPercentage >= 50 && getPercentage <= 74.999) {
    return fiftyPercent;
  }

  if (getPercentage >= 75 && getPercentage <= 99.999) {
    return seventyFivePercent;
  }

  if (getPercentage >= 100) {
    return undredPercent;
  }
};

export const BinCard = (
  storages: StoragesValuesView[],
  t: (arg0: string) => string
) => {
  const { setBin } = SetActions();

  return storages.map((values) => {
    const getPercentage =
      (100 * values?.usedCapacity?.value) / values?.totalCapacity?.value;

    return (
      <div
        key={values.id}
        onClick={() => setBin(values.id)}
        role="none"
        className="bin-card-container mt-2 mr-2"
      >
        <div className="bin-information">
          <div className="bin-card-name-loc">{values.name}</div>

          <div className="bin-information-card-specie">
            <div className="left-information-card-specie">
              {t("Common_options.specie")}
            </div>
            <div
              className="chip-cereal-card-loc-view"
              style={{
                background: `${values.cerealType?.iconBackgroundHexColor}`,
              }}
            >
              {values.cerealType?.textId?.text}
            </div>
          </div>

          <div className="bin-information-card-specie">
            <div className="left-information-card-specie">
              {t("Gran_tracker_bins.available-capacity")}
            </div>
            <div className="chip-cereal-card-loc-view">
              <div>
                {formatValueWithTooltip(
                  (values?.totalCapacity?.value ?? 0) -
                    (values?.usedCapacity?.value ?? 0),
                  values.totalCapacity?.unit?.unitSymbolTextId.text
                )}
              </div>
              <div>/</div>
              <div className="tons-card-available-loc-details">
                {formatValueWithTooltip(
                  values?.totalCapacity?.value,
                  values.totalCapacity?.unit?.unitSymbolTextId.text
                )}
              </div>
              <Tooltip
                title={values?.totalCapacity?.unit?.unitDescriptionTextId?.text}
                sx={{ marginLeft: "10px" }}
              >
                <InfoOutlinedIcon sx={{ fontSize: "16px" }} />
              </Tooltip>
            </div>
          </div>

          {values.currentCharacteristics
            .slice(1)
            .filter((values) => values.type == "allotmentPolicy").length > 0 ? (
            <div className="bin-card-subtitle-loc">
              {t("Selected_bin.allocation_plan")}
            </div>
          ) : null}

          <div className="characteristics-container-card">
            {values.currentCharacteristics
              .slice(1)
              .filter((values) => values.type == "allotmentPolicy")
              .map((values) => (
                <div
                  className="characteristics-container-card-info"
                  key={uuidv4()}
                >
                  <div>{values.name}</div>
                  <div> {values.value} </div>
                </div>
              ))}
          </div>

          {values.currentCharacteristics
            .slice(1)
            .filter((values) => values.type == "currentState").length > 0 ? (
            <div className="bin-card-subtitle-loc bin-card-subtitle-spacer">
              {t("Selected_bin.average-cell")}
            </div>
          ) : null}

          <div className="characteristics-container-card">
            {values.currentCharacteristics
              .slice(1)
              .filter((values) => values.type == "currentState")
              .map((values) => (
                <div
                  className="characteristics-container-card-info"
                  key={uuidv4()}
                >
                  <div>{values.name}</div>
                  <div> {values.value} </div>
                </div>
              ))}
          </div>
        </div>
        <div className="bin-svg">
          <img
            className="percentages-img-svg-location-empty"
            src={ceroPercent}
            alt={"silo"}
          />
          {getPercentage >= 25 ? (
            <img
              className={
                getPercentage >= 100
                  ? "percentages-img-svg-location-hundred"
                  : "percentages-img-svg-location"
              }
              src={showCorrectSVG(getPercentage)}
              style={{
                backgroundColor: `${values.cerealType?.iconBackgroundHexColor}`,
              }}
              alt={"silo"}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  });
};
